<!--
 * @Author: scg
 * @Date: 2021-12-27 14:04:40
 * @LastEditTime: 2022-03-18 10:59:50
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="Keylogger">
      <div class="div">{{ $t("screenRecording.title") }}</div>
      <el-select @change="getlist()" class="countrys" v-model="key.pkg">
        <el-option :label="$t('All')" :value="0"></el-option>
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div class="div" style="padding-left: 20px;">{{ $t("ScreenshotType") }}</div>
      <el-select @change="getlist()" class="countrys" v-model="key.type">
        <el-option :label="$t('All')" :value="0"></el-option>
        <el-option :label="$t('ScreenshotPhoto')" :value="1"></el-option>
        <el-option :label="$t('ScreenshotVideo')" :value="2"></el-option>
      </el-select>
    </div>
    <!-- <div v-if="list.length <=0" class="no-recent-activity">No Recent Activity</div> -->
    <div ref="imgbody">
      <div class="photos_li" v-for="(val, key) in list" :key="key">
        <div class="img">
          <el-image
            v-if="val.type == 1"
            :src="val.url"
            :preview-src-list="[val.url]"
            :initial-index="1"
          >
          </el-image>

          <video
            v-if="val.type == 2"
            style="width: 100%;"
            class="video-js"
            controls
            preload="auto"
            width="100%"
            height="100%"
            data-setup="{}"
            muted
          >
            <source :src="val.url" type="video/mp4" />
          </video>
          <!-- <img :src="val.url" /> -->
        </div>
        <div class="time">
          {{ val.createtime }}
          <img @click="download(val.url)" src="@/assets/img/download.png" />
        </div>
      </div>
      <div class="noData" v-if="list.length <= 0 && status">
        {{ $t("screenRecording.no") }}
      </div>
    </div>
    <div class="pagination" v-if="code > 0">
      <el-pagination
        @current-change="setPage"
        background
        layout="prev, pager, next"
        :total="code"
        :page-size="20"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getRecording, AllApp } from "@/api/user";
import { downloadFilePic } from "@/api/getUrlBase64";
export default {
  name: "HelloWorld",
  data() {
    return {
      days: 60,
      key: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 20,
        starttime: "",
        endtime: "",
        pkg: 0,
        type: 0,
      },
      code: 0,
      value1: "", // 获取时间
      list: [],
      msg: "",
      options: [],
      isChecked: null,
      status: false,
    };
  },
  mounted() {
    let imgw = 220;
    this.$nextTick(() => {
      let hCount = (this.$refs.imgbody.clientWidth - 17) / imgw;
      let imgh = 3;
      this.key.limit = imgh * parseInt(hCount);
      this.handleCommand();
    });
    window.addEventListener("resize", () => {
      this.$nextTick(() => {
        let hCount = (this.$refs.imgbody.clientWidth - 17) / imgw;
        let imgh = 3;
        this.key.limit = imgh * parseInt(hCount);
        this.handleCommand();
      });
    });
    AllApp({ equipment_id: localStorage.getItem("systemId") }).then((res) => {
      this.options = res.data.list;
    });
  },
  methods: {
    download(imgUrl) {
      // getUrlBase64(imgUrl).then((base64) => {
      //   let link = document.createElement('a')
      //   link.href = base64
      //   link.download = 'syplix_photos.png'
      //   link.click()
      // })
      downloadFilePic(imgUrl);
    },
    handleCommand(event) {
      this.days = event;
      let end = new Date();
      let start = new Date(new Date().setDate(end.getDate() - 90));
      if (event) {
        this.days = event;
        start = new Date();
        this.isChecked = true;
        start.setTime(start.getTime() - 3600 * 1000 * 24 * event);
      }
      this.value1 = [start, end];
      console.log(this.value1);
      this.getlist();
    },

    setPage(e) {
      this.key.page = e;
      this.getlist();
    },
    getlist(a) {
      this.status = false;
      this.key.starttime =
        this.value1[0].getFullYear() +
        "-" +
        (this.value1[0].getMonth() < 9 ? "0" : "") +
        (this.value1[0].getMonth() + 1) +
        "-" +
        (this.value1[0].getDate() < 10 ? "0" : "") +
        this.value1[0].getDate();
      this.key.endtime =
        this.value1[1].getFullYear() +
        "-" +
        (this.value1[1].getMonth() < 9 ? "0" : "") +
        (this.value1[1].getMonth() + 1) +
        "-" +
        (this.value1[1].getDate() < 10 ? "0" : "") +
        this.value1[1].getDate();
      console.log(this.key);
      if (a) {
        this.key.page = a;
      }
      this.list = [];
      getRecording(this.key).then((adj) => {
        this.status = true;
        this.list = adj.data.list;
        this.code = adj.data.count;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-recent-activity {
  width: 100%;
  text-align: center;
  font-size: 14px !important;
  color: #333 !important;
  margin-top: 25rpx;
}
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}
.photos_li {
  /* float: left; */
  display: inline-block;
  background: #fff;
  -webkit-box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  min-width: 200px;
  height: 250px;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
  overflow: hidden;
}
.photos_li .img {
  width: 200px;
  height: 200px;
  overflow: hidden;
}
.photos_li .img img {
  width: 200px;
  height: 200px;
}
.photos_li .time {
  height: 50px;
  line-height: 50px;
  text-indent: 13px;
  font-size: 12px;
  color: #3f3f3f;
  overflow: hidden;
}
.photos_li .time img {
  height: 16px;
  width: 16px;
  float: right;
  margin: 17px 10px 0 0;
  cursor: pointer;
}

.Keylogger {
  padding: 20px 0;
  height: 36px;
  margin-left: 2.75%;
  display: flex;
  align-items: center;
}
.Keylogger .div {
  float: left;
  font-size: 13px;
  color: #45484d;
  letter-spacing: 0;
  height: 36px;
  line-height: 36px;
  padding-right: 20px;
  /* width: 80px; */
}
#country {
  float: left;
  width: 230px;
  height: 34px;
  background: #f6f8fa;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  margin-left: 10px;
  padding: 0 10px;
  font-size: 13px;
  color: #000927;
}
</style>



// WEBPACK FOOTER //
// src/components/screenRecording.vue